import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "..";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetZonesList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        secondary ? dispatch({ type: types.GET_USERGROUPS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_ZONES_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones/OrganizationZones/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_ZONES_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveZonesPagination: (paginationType) => (dispatch, store) => {
        const data = store().administration.zones;
        dispatch({ type: types.GET_ZONES_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },
    GetSecondaryZonesList: (onSuccess, secondary) => async (dispatch, store) => {
        dispatch({ type: types.GET_ZONES_SECONDARY_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones/AllOrganizationZones/" + store().currentuser.currentorganization.id,
            {
                method: "GET"
            }).then((data) => {
            dispatch({ type: types.GET_ZONES_SECONDARY_COMPLETED, payload: { results: data } });
            if (onSuccess) {onSuccess({ results: data });}
            return;
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetRestrictedZones: (onSuccess, accessRightLevel) => async (dispatch, store) => {
        if (!accessRightLevel || accessRightLevel <= 10) {
            if (onSuccess) {onSuccess({ results: [] });}
        }
        else if (accessRightLevel === 20) {
            await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones/GetRestrictedZones/" + store().currentuser.currentorganization.id,
                {
                    method: "GET"
                }).then((data) => {
                if (onSuccess) {onSuccess({ results: data });}
                return;
            }).catch( (data) => {
                console.log(data);
            });
        }
        else {
            dispatch({ type: types.GET_ZONES_SECONDARY_COMPLETED, payload: null });
            await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones/AllOrganizationZones/" + store().currentuser.currentorganization.id,
                {
                    method: "GET"
                }).then((data) => {
                dispatch({ type: types.GET_ZONES_SECONDARY_COMPLETED, payload: { results: data } });
                if (onSuccess) {onSuccess({ results: data });}
                return;
            }).catch( (data) => {
                console.log(data);
            });
        }
    },

    DeleteZone: (zoneId, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones/" + zoneId, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.zoneDeleted);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditZone: (changedZone, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones/" + changedZone.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedZone),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.zoneSaved);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });

    },

    CreateZone: (newZone, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Zones", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newZone),
            method: "POST"
        }).then((data) => {
            toast.success(strings.zoneSaved);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    }

};
